import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface FuncionEspecificaApi {
    id: number;
    subgrupoId: number;
    nombre: string;
    codigo: string;
    estado: string;
}

export interface FuncionEspecificaFiltros {
    id?: number;
    tipoProductoId?: number;
    subgrupoId?: number;
    estado?: string;
}

@Injectable({
    providedIn: 'root',
})
export class FuncionEspecificaService {
    private readonly _apiUrl = environment.apiSiriUrl;

    public constructor(private http: HttpClient) {}

    public getFuncionesEspecificas(
        filtros: FuncionEspecificaFiltros = {}
    ): Observable<FuncionEspecificaApi[]> {
        if (filtros.subgrupoId !== undefined && filtros.subgrupoId !== null) {
            return this.getFuncionesEspecificasPorSubgrupo(
                filtros?.tipoProductoId,
                filtros.subgrupoId,
                filtros.estado
            );
        }

        let params = new HttpParams();
        if (filtros.id !== undefined) {
            params = params.set('id', String(filtros.id));
        }
        if (filtros.tipoProductoId !== undefined) {
            params = params.set(
                'tipoProductoId',
                String(filtros.tipoProductoId)
            );
        }
        if (filtros.estado !== undefined) {
            params = params.set('estado', filtros.estado);
        }
        return this.http.get<FuncionEspecificaApi[]>(
            `${this._apiUrl}funcion-especifica`,
            { params }
        );
    }

    public getFuncionesEspecificasPorSubgrupo(
        tipoProductoId: number | undefined,
        subgrupoId: number,
        estado?: string
    ): Observable<FuncionEspecificaApi[]> {
        let params = new HttpParams();
        if (tipoProductoId !== undefined) {
            params = params.set('tipoProductoId', String(tipoProductoId));
        }
        if (estado !== undefined) {
            params = params.set('estado', estado);
        }
        return this.http.get<FuncionEspecificaApi[]>(
            `${this._apiUrl}funcion-especifica/subgrupo/${subgrupoId}`,
            { params }
        );
    }
}
